import {Component, OnInit} from '@angular/core';

import {Platform} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {StorageProvider} from './repository/storage';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {Child} from './repository/db/Child';
import {StringUtils} from './utils/string.utils';
import {AuthService} from './repository/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

    child: Child;
    activateChildMenu = false;

    public scopeParentPages = [
        {
            title: 'Dashboard',
            url: '/program/dashboard',
            icon: 'speedometer'
        },
        {
            title: 'Report',
            url: '/program/progress/report',
            icon: 'pie'
        },
        {
            title: 'Feedback List',
            url: '/program/feedback/list',
            icon: 'list'
        }
    ];
    public othersPages = [
        {
            title: 'Child List',
            url: '/child/list',
            icon: 'contact'
        },
        {
            title: 'Editt',
            url: '/scope/editt',
            icon: 'document'
        },
        {
            title: 'About',
            url: '/scope/about',
            icon: 'alert'
        },
        {
            title: 'Contact',
            url: '/scope/contact',
            icon: 'call'
        },
        {
            title: 'Logout',
            url: 'logout',
            icon: 'log-in'
        }
    ];

    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        public storage: StorageProvider,
        public router: Router,
        public auth: AuthService
    ) {
        this.initializeApp();
    }

    initializeApp() {
        this.platform.ready().then(() => {
            this.statusBar.styleDefault();
            this.splashScreen.hide();
        });
    }

    ngOnInit() {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                const routerUrl = this.router.url;
                if (!routerUrl.startsWith('/program') && !routerUrl.startsWith('/scope')) {
                    this.activateChildMenu = false;
                } else {
                    this.storage.fetchValue('childId').then((childId: string) => {
                        if (!StringUtils.isEmpty(childId)) {
                            this.activateChildMenu = true;
                            if (StringUtils.isNull(this.child) ||  childId != (this.child.id + '')) {
                                this.auth.childById(childId).then((obj: Child) => {
                                    this.child = obj;
                                }, (err) => {
                                    this.child = undefined;
                                    this.activateChildMenu = false;
                                });
                            }
                        }
                    });
                }
            });
    }

    route(p: any) {
        if (p.url == 'logout') {
            this.storage.clear().then(() => {
                this.router.navigateByUrl('/user/login');
            });
        } else {
            this.router.navigateByUrl(p.url);
        }
    }

}
